var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M6.53 5.47L12 10.94l5.47-5.47a.75.75 0 01.98-.07l.08.07c.3.3.3.77 0 1.06L13.06 12l5.47 5.47a.75.75 0 01-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 011.06-1.06z"}})}
var staticRenderFns = []

export { render, staticRenderFns }